export default __webpack_public_path__ + "static/media/3.241cc807.jpeg";